import { InputHTMLAttributes, forwardRef } from 'react';
import { COLORS } from '../../constants/theme';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  hint?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, hint, className = '', id, ...props }, ref) => {
    const inputId = id || label.toLowerCase().replace(/\s+/g, '-');

    return (
      <div className="space-y-1">
        <label
          htmlFor={inputId}
          className="block text-sm font-medium"
          style={{ color: COLORS.text.secondary }}
        >
          {label}
        </label>
        <input
          ref={ref}
          id={inputId}
          className={`w-full px-3 py-2 rounded-md focus:outline-none focus:ring-2 ${className}`}
          style={{
            backgroundColor: COLORS.inputBg,
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: error ? COLORS.negative : COLORS.inputBorder,
            color: COLORS.text.primary,
          }}
          {...props}
        />
        {hint && !error && (
          <p className="text-sm" style={{ color: COLORS.text.tertiary }}>
            {hint}
          </p>
        )}
        {error && (
          <p className="text-sm" style={{ color: COLORS.negative }}>
            {error}
          </p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';
